import * as R from 'ramda/src/index';
import moment from 'moment';
import {PUBLISH, replaceCmsUrl} from 'cms/helpers/common';

const sortByMostRecent = R.pipe(
  R.sortBy(R.prop('post_timestamp')),
  R.reverse
);

const getPosts = R.pipe(
  R.filter(({post_status}) => post_status === PUBLISH),
  R.map(R.pick(['ID', 'post_title', 'post_excerpt', 'permanlink', 'post_date_gmt', 'image'])),
  R.map((item) => {
    const momemtDate = moment(item.post_date_gmt);
    return {
      ...item,
      post_date_gmt: momemtDate.format('LL'),
      post_timestamp: momemtDate.unix(),
      permanlink: replaceCmsUrl(item.permanlink)
    };
  }),
  sortByMostRecent
);

export {getPosts, sortByMostRecent};
